import { Component, OnInit } from '@angular/core';
import { ActivatedRoute , Router} from '@angular/router';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs/Subscription';
import {Subject} from 'rxjs';
import {debounceTime} from 'rxjs/operators';

import { PaymentDetailsVo, WpVendor, WpPayment, WpPayee } from '../shared';
import { ReferenceTableService } from '../reference-table.service';
import { CommonUtility, ServerConstantsService } from '../shared';
import { DataService } from '../shared';
import { NotificationsService } from 'angular2-notifications';
import {NgbDateStruct} from "@ng-bootstrap/ng-bootstrap";


@Component({
  selector: 'app-payment-details',
  templateUrl: './payment-details.component.html',
  styleUrls: ['./payment-details.component.scss']
})
export class PaymentDetailsComponent implements OnInit {
  paymentDetailsVo : PaymentDetailsVo;
  wpVendor : WpVendor;
  wpPayee: WpPayee;
  stateArray:any[];
  refData: any;
  ServerConstants: any;
  stateMap:any;
  userActionNotificationsMap: any;

  wpPayment:WpPayment;
  paymentId:string = '';
  private _success = new Subject<string>();
  successMessage: string;
  errorRadioPaymentMode:Boolean = false;

  private _danger = new Subject<string>();
  errorMessage: string;
  referralId: string = '';
  wpPersonId: string = '';
  sharedData: any;

  minDate: NgbDateStruct;
  today: Date = new Date();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private data: ReferenceTableService,
    private commonUtil: CommonUtility,
    private dataService: DataService,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService
  ) {
    this.ServerConstants = serverConstantsService.getConstants();
  }

  ngOnInit() {

    this.paymentDetailsVo = new PaymentDetailsVo();
    this.sharedData = this.dataService.getSharedDataObject();

    /* set global values for page */
    this.referralId = this.sharedData.get('referralId');
    this.wpPersonId = this.sharedData.get('wpPersonId');
    this.paymentId = this.sharedData.get('wpPaymentId');

    this.paymentDetailsVo.paymentId = parseInt(this.paymentId);

    if(this.wpPayment == null){
      this.wpPayment = new WpPayment();
      this.wpVendor = new WpVendor();
      this.wpPayee = new WpPayee();
      this.wpPayment.wpVendor  =this.wpVendor;
      this.wpPayment.wpPayee  =this.wpPayee;
      this.paymentDetailsVo.wpPayment = this.wpPayment;
    }

    this.load();

    /* Success message*/
    this._success.subscribe((message) => this.successMessage = message);
    this._success.pipe(
      debounceTime(5000)
    ).subscribe(() => this.successMessage = null);
    /* error message */
    this._danger.subscribe((message) => this.errorMessage = message);
    this._danger.pipe(
      debounceTime(5000)
    ).subscribe(() => this.errorMessage = null);

    /* Load Reference Tables*/
    this.data.currentMessage.subscribe(
     (message) => {
         this.refData = message;
         this.parseRefTableData(message);
    });

    this.minDate = {
      month: this.today.getMonth() - 1,
      day: this.today.getDate(),
      year: this.today.getFullYear()
    };
  }

  radioPaymentMode(event) {
    this.errorRadioPaymentMode = false;
  }

  load(){
    this.http.post<PaymentDetailsVo>(this.ServerConstants.SERVER_API_URL + '/paymentdetails/load', this.paymentDetailsVo ).subscribe(
        (data: PaymentDetailsVo ) => {
            // convert date to the proper format for UI
            this.paymentDetailsVo = data;

             /*this.paymentDetailsVo.wpPayment.wpPayee = this.wpPayee;*/
             /*this.paymentDetailsVo.wpPayment.wpVendor = this.wpVendor;*/

            if(this.paymentDetailsVo.wpPayment.paymentMonth != null){
              this.paymentDetailsVo.wpPayment.paymentMonth = this.convertDateFromServer(this.paymentDetailsVo.wpPayment.paymentMonth);
            }
            if(this.paymentDetailsVo.wpPayment.wpPayee.addrZip5 == " "){
               this.paymentDetailsVo.wpPayment.wpPayee.addrZip5 = null;

             }

             if(this.paymentDetailsVo.wpPayment.wpPayee.payeeeName == " "){
               this.paymentDetailsVo.wpPayment.wpPayee.payeeeName = null;

             }
             if(this.paymentDetailsVo.wpPayment.wpPayee.addrCity == " "){
              this.paymentDetailsVo.wpPayment.wpPayee.addrCity = null;

            }

            if(this.paymentDetailsVo.wpPayment.wpVendor.vendorName == " "){
             this.paymentDetailsVo.wpPayment.wpVendor.vendorName = null;

            }

            if(this.paymentDetailsVo.wpPayment.wpVendor.vendorContactPersonName == " "){
             this.paymentDetailsVo.wpPayment.wpVendor.vendorContactPersonName = null;

            }

            if(this.paymentDetailsVo.wpPayment.wpVendor.addrCity == " "){
             this.paymentDetailsVo.wpPayment.wpVendor.addrCity = null;

            }

            if(this.paymentDetailsVo.wpPayment.wpVendor.addrZip5 == " "){
             this.paymentDetailsVo.wpPayment.wpVendor.addrZip5 = null;

            }

        },response => {
            //Display failure message
            this.notificationService.error('Payment', this.userActionNotificationsMap.ERROR);
        },() => {
      });

  }

  convertDateFromServer(value){
      let myDateObj ={year:'',month:'',day:''};
      myDateObj.year = value[0];
      myDateObj.month = value[1];
      myDateObj.day = value[2];
      return myDateObj;
  }

  convertDateForServer(value){
    if (value) {
      let myDay = value.day;
      let myMonth = value.month;
      let myYear = value.year;
      if(myDay < 10 ) {
          myDay = '0'+ myDay;
      }
      if(myMonth < 10) {
          myMonth = '0'+ myMonth;
      }
      return myYear + '-' + myMonth + '-'+ myDay ;
    }
  }

  parseRefTableData(myData){
    if(myData != undefined && myData.englishDropDown){
       this.stateArray =myData.englishDropDown["STATE"];
       this.stateMap = this.commonUtil.createMapFromList(this.stateArray);
       this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(myData.englishDropDown["USER-ACTION-NOTIFICATIONS"]);
    }
  }

  submitnpaymentDetails(){
    if(this.paymentDetailsVo.wpPayment.paymentModeCd  == null){
      this.errorRadioPaymentMode = true;
    }else{
      this.errorRadioPaymentMode = false;
    }

    //Convert date for backend before sending
    if(this.paymentDetailsVo.wpPayment.paymentMonth != null){
      this.paymentDetailsVo.wpPayment.paymentMonth = this.convertDateForServer(this.paymentDetailsVo.wpPayment.paymentMonth);
    }

    this.http.post<PaymentDetailsVo>(this.ServerConstants.SERVER_API_URL + '/paymentdetails/save', this.paymentDetailsVo ).subscribe(
      (data: PaymentDetailsVo ) => {
        //Convert date to the proper format for UI
        this.paymentDetailsVo = data;
        if(this.paymentDetailsVo.wpPayment.paymentMonth != null){
          this.paymentDetailsVo.wpPayment.paymentMonth = this.convertDateFromServer(this.paymentDetailsVo.wpPayment.paymentMonth);
        }
      },
      response => {
        //Display failure message
        this.notificationService.error('Payment', this.userActionNotificationsMap.ERROR);
      },
      () => {
        //Display Toast notification
        this.notificationService.success('Payment', this.userActionNotificationsMap.UPDATE);

        this.router.navigate(['/task/paymentSummary']);
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/payment-details/payment-details.component.ts